import { render, staticRenderFns } from "./DetailTechnicianBooking.vue?vue&type=template&id=2f59bbfc&scoped=true&"
import script from "./DetailTechnicianBooking.vue?vue&type=script&lang=js&"
export * from "./DetailTechnicianBooking.vue?vue&type=script&lang=js&"
import style0 from "./DetailTechnicianBooking.vue?vue&type=style&index=0&id=2f59bbfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f59bbfc",
  null
  
)

export default component.exports